module.exports = __webpack_public_path__ + "static/media/facebook-color.27d8ed93.svg";